(function () {
  'use strict';

  var bar = document.querySelector('.js-cc-fsbar');
  if (!bar) return;

  var threshold      = parseFloat(bar.dataset.threshold) || 99;
  var reviewCountUrl = bar.dataset.reviewUrl || 'https://t.convertcart.com/review/10198674/product/list/';

  var elPreAdd       = bar.querySelector('.js-cc-fsbar-pre-add');
  var elProgressText = bar.querySelector('.js-cc-fsbar-progress-text');
  var elProgressWrap = bar.querySelector('.js-cc-fsbar-progress-wrap');
  var elFill         = bar.querySelector('.js-cc-fsbar-fill');
  var elReviewCount  = bar.querySelector('.js-cc-fsbar-review-count');

  /* ── Live review count ─────────────────────────────────────── */
  function fetchReviewCount() {
    if (!elReviewCount) return;
    fetch(reviewCountUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.summary && data.summary.count) {
          elReviewCount.textContent = data.summary.count + ' Reviews';
        }
      })
      .catch(function () {});
  }

  /* ── Bar UI update (totalCents = Shopify cents e.g. 1999 = $19.99) ── */
  function updateBar(totalCents) {
    var rate  = (window.Shopify && Shopify.currency &&
                 (Shopify.currency.rate || Shopify.currency.conversion_rate)) || 1;
    var limit = threshold * rate;
    var total = totalCents / 100;
    var sign  = (window.theme && theme.moneyFormat)
                  ? theme.moneyFormat.split('{{')[0]
                  : '$';

    if (total <= 0) {
      elPreAdd.hidden       = false;
      elProgressText.hidden = true;
      elProgressWrap.hidden = true;

    } else if (total < limit) {
      var remaining = (limit - total).toFixed(2);
      var pct       = Math.min(Math.round((total / limit) * 100), 99);

      elPreAdd.hidden       = true;
      elProgressText.hidden = false;
      elProgressWrap.hidden = false;

      elProgressText.innerHTML =
        'You are <strong>' + sign + remaining + '</strong> away from <strong>FREE SHIPPING!</strong>';
      elFill.style.width = pct + '%';
      elFill.classList.remove('is-full');

    } else {
      elPreAdd.hidden       = true;
      elProgressText.hidden = false;
      elProgressWrap.hidden = false;

      elProgressText.innerHTML = "Congratulations! You've earned <strong>FREE SHIPPING!</strong>";
      elFill.style.width = '100%';
      elFill.classList.add('is-full');
    }
  }

  /* ── Fetch real cart total from Shopify ────────────────────── */
  function fetchCartAndUpdate() {
    fetch('/cart.json')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateBar(cart.total_price || 0);
      })
      .catch(function () {
        updateBar(0);
      });
  }

  /* ── Boot ──────────────────────────────────────────────────── */
  fetchReviewCount();
  fetchCartAndUpdate();

  /* Re-check cart every 3 seconds (picks up add-to-cart events) */
  setInterval(fetchCartAndUpdate, 3000);

  /* ── Keep bar visible when CC JS makes the header position:fixed ── */
  var sectionBar    = document.getElementById('shopify-section-free-shipping-bar');
  var sectionHeader = document.getElementById('shopify-section-header');

  if (sectionBar && sectionHeader) {
    var observer = new MutationObserver(function () {
      if (sectionHeader.classList.contains('cc-sticky-Navmenubar')) {
        var barH = sectionBar.offsetHeight;
        sectionBar.style.cssText  = 'position:fixed;top:0;width:100%;z-index:1001;';
        sectionHeader.style.top   = barH + 'px';
      } else {
        sectionBar.style.cssText = '';
        sectionHeader.style.top  = '';
      }
    });
    observer.observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });
  }

}());
